/**
 * Returns the vacancies overview URL for the given locale.
 * NL: /vacatures, EN: /en/vacancies
 */
export function getVacanciesOverviewPath(locale: string): string {
    return locale === 'nl' ? '/vacatures' : `/${locale}/vacancies`;
}

/**
 * Returns the vacancy detail URL for the given locale and slug.
 * NL: /vacatures/[slug], EN: /en/vacancies/[slug]
 */
export function getVacancyDetailPath(locale: string, slug: string): string {
    const base = getVacanciesOverviewPath(locale);
    return `${base}/${slug}`;
}
